// extracted by mini-css-extract-plugin
export var headerCell = "_1m-1";
export var loadingStateCell = "_1m-4";
export var rowWrapper = "_1m-3";
export var standaloneTable = "_1m-5";
export var table = "_1m-0";
export var white = "_1m-2";